<form #modalForm="ngForm">
  <div class="modal modal-blur fade" id="cari-kayit-modal" tabindex="-1" style="display: none;" aria-hidden="true"
    data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" [innerText]="isPublic ? 'Cari Düzenle' : 'Yeni Cari Kayıt'"></h5>
          <!-- <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button> -->
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label">Firma Ünvanı</label>
            <input type="text" class="form-control" name="firmaUnvani" placeholder="Firma Ünvanı"
              [(ngModel)]="cari.firmaUnvani" oninput="this.value = this.value.toUpperCase()">
          </div>

          <div class="row">
            <div class="mb-3 col-lg-6">
              <label class="form-label">Yetkili Kişi</label>
              <input type="text" class="form-control" name="yetkiliKisi" placeholder="Yetkili Kisi"
                [(ngModel)]="cari.yetkiliKisi" oninput="this.value = this.value.toUpperCase()">
            </div>

            <div class="mb-3 col-lg-6">
              <label class="form-label">Mail Adresi</label>
              <input type="text" class="form-control" name="mailAdresi" placeholder="Mail Adresi" [(ngModel)]="cari.mailAdresi">
                <!--  oninput="this.value = this.value.toLowerCase()"   caps açıkken mail gitmiyor bu olduğunda -->  
              <!-- (ngModelChange)="cari.mailAdresi=$event.toLowerCase()" -->
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label">Firma Adresi</label>
            <input type="text" class="form-control" name="firmaAdresi" placeholder="Firma Adresi"
              [(ngModel)]="cari.firmaAdresi" oninput="this.value = this.value.toUpperCase()">
            <!-- (ngModelChange)="cari.firmaAdresi=$event.toUpperCase()" -->
          </div>

          <div class="row">
            <div class="mb-3 col-lg-6">
              <label class="form-label">İl</label>
              <app-loading-input *ngIf="!sehirler"></app-loading-input>
              <select *ngIf="sehirler" class="form-control" [(ngModel)]="cari.sehirId"
                [ngModelOptions]="{standalone: true}">
                <option [value]="null" disabled selected>Şeçiniz</option>
                <option *ngFor="let p of sehirler" [ngValue]="p.id">{{p.aciklama}}</option>
              </select>
            </div>

            <div class="mb-3 col-lg-6">
              <label class="form-label">İlçe</label>
              <input type="text" class="form-control" name="ilce" placeholder="İlçe" [(ngModel)]="cari.ilce"
                oninput="this.value = this.value.toUpperCase()">
              <!-- (ngModelChange)="cari.ilce=$event.toUpperCase()" -->
            </div>
          </div>

          <div class="row">
            <div class="col-lg-4">
              <div class="mb-3">
                <label class="form-label">Telefon</label>
                <input type="text" class="form-control" name="telefon" placeholder="Telefon" [(ngModel)]="cari.telefon"
                  oninput="this.value = this.value.toUpperCase()">
                <!-- (ngModelChange)="cari.telefon=$event.toUpperCase()" -->
              </div>
            </div>
            <div class="col-lg-4">
              <div class="mb-3">
                <label class="form-label">Cep Telefonu</label>
                <input type="text" class="form-control" name="cepTelefon" placeholder="Cep Telefonu"
                  [(ngModel)]="cari.cepTelefon" oninput="this.value = this.value.toUpperCase()">
                <!-- (ngModelChange)="cari.cepTelefon=$event.toUpperCase()" -->
              </div>
            </div>
            <div class="col-lg-4">
              <div class="mb-3">
                <label class="form-label">Faks</label>
                <input type="text" class="form-control" name="faks" placeholder="Faks" [(ngModel)]="cari.faks"
                  oninput="this.value = this.value.toUpperCase()">
                <!-- (ngModelChange)="cari.faks=$event.toUpperCase()" -->
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-4">
              <div class="mb-3">
                <label class="form-label">Vergi Dairesi</label>
                <input type="text" class="form-control" name="vergiDairesi" placeholder="Vergi Dairesi"
                  [(ngModel)]="cari.vergiDairesi" oninput="this.value = this.value.toUpperCase()">
                <!-- (ngModelChange)="cari.vergiDairesi=$event.toUpperCase()" -->
              </div>
            </div>
            <div class="col-lg-4">
              <div class="mb-3">
                <label class="form-label">Vergi No</label>
                <input [maxlength] = "10" type="text" class="form-control" name="vergiNo" placeholder="Vergi No" [(ngModel)]="cari.vergiNo"
                  oninput="this.value = this.value.toUpperCase()">
                <!-- (ngModelChange)="cari.vergiNo=$event.toUpperCase()" -->
              </div>
            </div>
            <div class="col-lg-4">
              <div class="mb-3">
                <label class="form-label">TC Kimlik No</label>
                <input  [maxlength] = "11" type="text" class="form-control" name="tcNo" placeholder="TC Kimlik No" [(ngModel)]="cari.tcNo"
                  oninput="this.value = this.value.toUpperCase()">
                <!-- (ngModelChange)="cari.tCNo=$event.toUpperCase()" -->
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-8">
              <div class="mb-3">
                <label class="form-label">IBAN No</label>
                <input type="text" class="form-control" name="ibanNo" placeholder="IBAN No" [(ngModel)]="cari.ibanNo"
                  oninput="this.value = this.value.toUpperCase()">
                <!-- (ngModelChange)="cari.ibanNo=$event.toUpperCase()" -->
              </div>
            </div>

            <div class="col-lg-4" [hidden]="true">
              <div class="mb-3">
                <label class="form-label">Cari Kodu</label>
                <input type="text" class="form-control" name="cariKodu" placeholder="Cari Kodu" readonly="true"
                  [(ngModel)]="cari.cariKodu">
              </div>
            </div>

            <!-- <div class="col-lg-4">
            <div class="mb-3">
              <label class="form-label">Cari Grubu</label>
              <input type="text" class="form-control" placeholder="Cari Grubu">
            </div>
          </div>
          <div class="col-lg-4">
            <div class="mb-3">
              <label class="form-label">Dövizli Cari Türü</label>
              <app-loading-input *ngIf="paraBirimleri==null"></app-loading-input>
              <select *ngIf="paraBirimleri" class="form-control" [(ngModel)]="paraBirimiId"
                [ngModelOptions]="{standalone: true}">
                <option [value]="null" disabled selected>Şeçiniz</option>
                <option *ngFor="let p of paraBirimleri" [ngValue]="p.id">{{p.aciklama}}</option>
              </select>
            </div>
          </div> -->
            <!-- <div class="col-lg-4">
              <div class="mb-3">
                <label class="form-label">Vade <span>(Gün)</span></label>
                <input type="text" class="form-control" name="vadeGunu" placeholder="Vade" [(ngModel)]="cari.vadeGunu">
              </div>
            </div> -->
          </div>
          <div class="row">
            <div class="col-lg-6">
              <div *ngIf="!isPublic">
                <label class="form-check">
                  <input class="form-check-input" name="mailGonder" type="checkbox" [(ngModel)]="mailGonder">
                  <span class="form-check-label">Cari Bilgi Formunu Mail Gönder</span>
                </label>
              </div>
            </div>

            <div class="col-lg-6">
              <div *ngIf="!isPublic">
                <label class="form-check">
                  <input class="form-check-input" name="onayMailGonder" type="checkbox" [(ngModel)]="onayMailGonder">
                  <span class="form-check-label">Cariyi Onaya Gönder</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <a href="#" class="btn btn-link link-secondary" data-dismiss="modal">
            Kapat
          </a>

          <button type="button" class="btn btn-primary ml-auto" (click)="cariKaydet()">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
              stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
            Kaydet
          </button>


          <button type="button" class="btn btn-success ml-auto" (click)="netsiseAktar()" [hidden]="aktarimHidden">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
              stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <circle cx="12" cy="12" r="9" />
              <line x1="12" y1="8" x2="8" y2="12" />
              <line x1="12" y1="8" x2="12" y2="16" />
              <line x1="16" y1="12" x2="12" y2="8" />
            </svg>
            Netsise Aktar
          </button>

          <!-- <a href="#" class="btn btn-primary ml-auto" data-dismiss="modal" (click)="cariKaydet()">
          <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
            stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
          Kaydet
        </a> -->
        </div>
      </div>
    </div>
  </div>
</form>